import { useGetMeQuery } from '@/services/gql/graphql.generated';
import { EmployeeSchedule } from '../employee/schedule/schedule.types';
import { useSaveSchedule } from './useSaveSchedule';

export const useSaveMySchedule = (startDate: Date, endDate: Date) => {
  const [{ data: userData }] = useGetMeQuery();
  const { save: saveSchedule, fetching } = useSaveSchedule(startDate, endDate, true);

  const employeeId = userData?.myEmployee?.identityId;
  if (!employeeId) {
    throw Error("Could not get current user's identity ID");
  }

  const save = (schedule: EmployeeSchedule) => saveSchedule(employeeId, schedule);

  return { save, fetching };
};
